import Enum from "./Enum";

export default Enum.create( {
	HEADING: "HEADING",
} );
